let setCartPosition;

function openCartDrawerV2() {
  document.querySelectorAll("[data-open-cart-drawer]").forEach((openEl) => {
    openEl.setAttribute("aria-expanded", "true");
  });

  document
    .querySelector("car-drawer-v2")
    .dispatchEvent(new CustomEvent("openCartDrawerV2"));
}

function closeCartDrawerV2() {
  document.querySelectorAll("[data-open-cart-drawer]").forEach((openEl) => {
    openEl.setAttribute("aria-expanded", "false");
  });
  document
    .querySelector("car-drawer-v2")
    .dispatchEvent(new CustomEvent("closeCartDrawerV2"));
}

class CartDrawerV2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("openCartDrawerV2", () => this.open());
    this.addEventListener("closeCartDrawerV2", () => this.close());

    this.positioner = this.querySelector(".drawer-v2__positioner");
    this.background = document.querySelector(".drawer-v2__bg");
    this.container = this.querySelector("#shopify-section-cart-drawer_v2");

    this.registerListeners();
    this.freeShipping();

    const urlSearchParams = new URLSearchParams(window.location.search);
    if (urlSearchParams.get("openCartDrawerV2") != null) {
      this.open();
    }
  }

  setDiscountCode() {
    const currentBundleCodeEl = document.querySelector(
      ".drawer-v2__card[data-bundle-code]",
    );
    const discountCodeEl = document.querySelector("[data-discount-code]");
    if (currentBundleCodeEl) {
      if (discountCodeEl) {
        discountCodeEl.value = currentBundleCodeEl.dataset.bundleCode;
      }
    } else {
      if (discountCodeEl) {
        discountCodeEl.value = "";
      }
    }
  }

  async setCountOfItems() {
    let cartAccent = document.querySelector(".site-header__icon--cart-accent");
    const currentCart = await fetch("/cart.js");
    const currentCartData = await currentCart.json();
    cartAccent.textContent = currentCartData.item_count;
    if (currentCartData.item_count > 0) {
      console.log(cartAccent.parentElement);
      cartAccent.classList.remove("hide");
    } else {
      cartAccent.classList.add("hide");
    }
  }

  scrollToCurrentPosition() {
    const getElement = this.querySelector(".drawer-v2__body");
    getElement.scrollTop = setCartPosition;
    const getBtn = document.querySelectorAll(".drawer-v2__card-btn");

    getBtn.forEach((btn) => {
      btn.addEventListener("click", () => {
        setCartPosition = getElement.scrollTop;
      });
    });
  }

  open() {
    this.toggle(true);
    this.render();
    const body = document.querySelector("body");
    const header = document.querySelector("header");
    const documentWidth = document.documentElement.clientWidth;
    const windowWidth = window.innerWidth;
    const scrollBarWidth = windowWidth - documentWidth;
    body.style.paddingRight = `${scrollBarWidth}px`;
    body.style.overflow = "hidden";
    header.style.paddingRight = `${scrollBarWidth}px`;
    this.setDiscountCode();
    this.querySelector(".drawer-v2__positioner").setAttribute(
      "aria-hidden",
      "false",
    );
  }

  close() {
    this.toggle(false);
    const body = document.querySelector("body");
    const header = document.querySelector("header");
    header.style.paddingRight = "0";
    body.style.paddingRight = "0";
    body.style.overflow = "auto";
    setCartPosition = 0;
    this.querySelector(".drawer-v2__positioner").setAttribute(
      "aria-hidden",
      "true",
    );
  }

  toggle(show) {
    if (show == true) {
      this.positioner.setAttribute("data-show", "transition");
      setTimeout(() => {
        this.positioner.setAttribute("data-show", "true");
        setTimeout(() => {
          this.positioner.focus();
        }, 100);
      }, 10);
    } else {
      this.positioner.setAttribute("data-show", "transition");
      setTimeout(() => {
        this.positioner.setAttribute("data-show", "false");
      }, 10);
    }
    this.background.setAttribute("data-show", show.toString());
    document
      .querySelector(".search-form__desktop")
      .setAttribute("data-show", !show);
  }

  async render() {
    const newHTML = await this.fetchSection();

    const parser = new DOMParser();
    var resAsHtml = parser.parseFromString(newHTML, "text/html");

    const updatedCart = resAsHtml.querySelector(".drawer-v2__positioner");

    const currentContent = this.querySelector(".drawer-v2__wrapper");
    const newContent = updatedCart.querySelector(".drawer-v2__wrapper");

    if (currentContent.innerHTML === newContent.innerHTML) return;

    currentContent.innerHTML = newContent.innerHTML;
    this.registerListeners();
    this.freeShipping();
    this.scrollToCurrentPosition();
    this.setDiscountCode();
    this.setCountOfItems();

    registerCustomGa4EventElements();
  }

  registerListeners() {
    this.querySelectorAll(
      ".drawer-v2__card-btn, .drawer-v2__card-remove",
    ).forEach((item) => {
      item.addEventListener("click", () => this.handleQuantityChange(item));
    });
  }

  handleQuantityChange(item) {
    const itemAction = item.getAttribute("data-action");

    if (itemAction === "remove") {
      this.updateQuantity(item.getAttribute("data-key"), 0);
      return;
    }

    const container = item.parentElement;
    const currentQuantity = parseInt(container.getAttribute("data-quantity"));
    const currentKey = container.getAttribute("data-key");
    const quantityChange = itemAction === "plus" ? 1 : -1;
    this.updateQuantity(currentKey, currentQuantity + quantityChange);
  }

  async updateQuantity(key, quantity) {
    const res = await this.fetchQuantity(key, quantity);

    if (res.status == 200) {
      this.render();
    } else {
      if (res.status == 422) {
        alert(
          "Es tut uns leid, aber du kannst momentan keine höhere Anzahl auswählen",
        );
      } else {
        alert(
          "An error occurred while updating your cart. Please contact the support.",
        );
      }
    }
  }

  async fetchSection() {
    const res = await fetch(
      window.Shopify.routes.root + "?section_id=cart-drawer_v2",
    );
    const text = await res.text();
    return text;
  }

  async fetchQuantity(key, quantity) {
    const updates = {};
    updates[key] = quantity;
    const data = {
      updates,
    };
    const config = fetchConfig();
    config.body = JSON.stringify(data);

    const res = await fetch(
      window.Shopify.routes.root + "cart/update.js",
      config,
    );
    return res;
  }

  async freeShipping() {
    const currentLocationFetch = await fetch(
      "/browsing_context_suggestions.json",
    );
    const currentLocation = await currentLocationFetch.json();
    const currentCountry =
      currentLocation?.detected_values?.country?.handle || "DE";
    const isAbroad = currentCountry === "DE" ? false : true;

    const lineEl = this.querySelector(".drawer-v2__progress-line");
    const maxGermany = lineEl?.dataset.freeShippingGermany;
    const maxAbroad = lineEl?.dataset.freeShippingAbroad;

    console.log(maxGermany);

    const max = isAbroad ? maxAbroad : maxGermany;

    lineEl?.setAttribute("max", max);

    const text = document.querySelector(".drawer-v2__change-text");
    const textMissing = text.dataset.missing || "";
    const textSuccess = text.dataset.success;
    const progress = document.querySelector(".drawer-v2__progress-line");

    if (progress) {
      if (progress.value >= max) {
        text.textContent = textSuccess;
      } else {
        text.textContent = textMissing.replace(
          "%p",
          max - progress.value + "€",
        );
      }
    }
  }
}
customElements.define("car-drawer-v2", CartDrawerV2);

class CartDrawerDiscount extends HTMLElement {
  constructor() {
    super();
    this.querySelector(".drawer-v2__discount-field-top").addEventListener(
      "click",
      () => {
        this.toggle();
      },
    );

    this.applyBtn = this.querySelector(".drawer-v2__discount-field-apply");
    this.codeInput = this.querySelector(
      ".drawer-v2__discount-field-bottom-top input",
    );
    this.codeSuccessLabel = this.querySelector("[data-coupon-code]");

    this.removeButtons = this.querySelectorAll(
      ".drawer-v2__discount-field-active-tile-remove",
    );

    this.discountCodeList = this.dataset.currentDiscountCodeList;
    this.availableSitecodes = JSON.parse(
      this.dataset.availableSitecodes || "[]",
    );

    this.removeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.removeDiscounts();
      });
    });

    this.applyBtn.addEventListener("click", () => {
      this.applyDiscount();
    });
  }

  toggle() {
    const currentlyOpened = this.dataset.open === "true";
    this.setAttribute("data-open", !currentlyOpened);
  }

  async applyDiscount() {
    if (this.applyBtn.dataset.state === "loading") {
      return;
    }

    const currentCode = this.codeInput.value;

    if (currentCode === "") {
      alert("Bitte gib einen Rabattcode ein");
      return;
    }

    if (this.discountCodeList != "") {
      alert(this.dataset.removeDiscountMessage);
      return;
    }

    this.applyBtn.dataset.state = "loading";

    const addVariantData = await this.checkForSitecodeAddedVariant(currentCode);
    if (addVariantData != null) {
      const currentCart = await fetch("/cart.js");
      const currentCartData = await currentCart.json();
      const containsVariant = currentCartData.items.some((item) => {
        return item.variant_id == addVariantData.variantId;
      });

      if (!containsVariant) {
        await addToCart(addVariantData.variantId, addVariantData.quantity);
      }
    }

    await setDiscountCode(currentCode);
    await document.querySelector("car-drawer-v2").render();

    // After calling render, there is a new discount element
    const cartDrawerDiscount = document.querySelector(
      "cart-drawer-v2-discount",
    );
    // Always keep the discount field open
    cartDrawerDiscount.setAttribute("data-open", "true");

    const currentDiscountCodeList =
      cartDrawerDiscount.getCurrentDiscountCodeList();

    if (!currentDiscountCodeList.includes(currentCode.toUpperCase())) {
      cartDrawerDiscount.querySelector(
        ".drawer-v2__discount-field-bottom-top input",
      ).value = currentCode;
      cartDrawerDiscount.setAttribute("data-state", "error");
      // Remove toggle so the field stays open
      localStorage.setItem(
        "sitecode_v2",
        JSON.stringify({
          code: currentCode,
          savedAt: Date.now(),
        }),
      );
    }
  }

  async checkForSitecodeAddedVariant(sitecode) {
    const urlParams = new URLSearchParams();
    urlParams.set("codes", sitecode);
    const fetchUrl =
      "https://purish-worker.kevinschade.workers.dev/gwp-code-info?" +
      urlParams.toString();

    const fetchRes = await fetch(fetchUrl);

    if (!fetchRes.ok) {
      console.log("FetchRes not ok", fetchRes);
      return null;
    }

    const gwpJson = await fetchRes.json();

    if (!("gwpIds" in gwpJson)) {
      console.log("No gwpIds found");
      return null;
    }

    if (gwpJson["gwpIds"].length == 0) {
      return null;
    }

    const firstGwpId = gwpJson["gwpIds"][0].replace(
      "gid://shopify/ProductVariant/",
      "",
    );

    return {
      variantId: firstGwpId,
      quantity: 1,
    };
  }

  async removeDiscounts() {
    this.applyBtn.dataset.state = "loading";
    await fetch(Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        discount: "",
      }),
    });
    await document.querySelector("car-drawer-v2").render();

    // After calling render, there is a new discount element
    const cartDrawerDiscount = document.querySelector(
      "cart-drawer-v2-discount",
    );

    // Always keep the discount field open
    cartDrawerDiscount.setAttribute("data-open", "true");
  }

  getCurrentDiscountCodeList() {
    return this.dataset.currentDiscountCodeList
      .split(",")
      .map((discount) => discount.toUpperCase());
  }
}

customElements.define("cart-drawer-v2-discount", CartDrawerDiscount);
